


















import Vue from 'vue'

export default Vue.extend({
  name: 'WarningDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    warningTitle: String,
    warningText: String
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onNoButtonClick (): void {
      this.$emit('close')
    },

    onYesButtonClick (): void {
      this.$emit('save')
    }
  },

  mounted (): void {
    setTimeout(() => {
      const yesBtn: any = this.$refs['yesBtn']
      if (yesBtn) {
        yesBtn.$el.focus()
      }
    })
  }
})
